<header class="sub-page-layout__header occurrenceCode__header">
  <div class="occurrenceCode__header-text h2 h2--semi-bold">Occurrence Span Codes</div>
  <mat-slide-toggle
    class="occurrenceCode__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="occurrenceCode__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Occurrence Span Codes
  </button>
  <button
    mat-flat-button
    color="primary"
    class="occurrenceCode__add-item"
    (click)="addOccurrenceSpanCode()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Occurrence Span Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Occurrence Span Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="occurrenceCode__footer">
  <lib-button-loading color="primary" class="occurrenceSpanCode__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
